export default {
  // new
  plans: {
    chooseYourPlan: 'Choose your plan',
    selectPerfectPlan: 'Select the perfect plan for your organization',

    monthly: 'Monthly',
    annual: 'Annual',
    save10: 'Save 10%',

    title: 'CoNurse Plan',
    description: 'Access all currently available features on CoNurse.',

    numberOfUsers: 'Number of users',

    selectPlan: 'Select plan',
    continueToBilling: 'Continue to billing details',

    featureHospital: 'Hospital & home nursing functionalities',
    featureProcedures: 'Institution-specific procedures',
    featurePatientManagement: 'Patient management',
    featureHomeCare: 'Home care functionalities',
    featureMaps: 'Google Maps integration for home nursing',
    featureWellbeing: 'Nurse wellbeing monitoring',
  },
  errors: {
    // new
    email_duplicate: 'Dublicate emails.',
    oneEmail: 'At least one email is required.',
    // end new
    required: 'This field is required',
    password_invalid:
      'Password must be at least 8 characters long, contain upper and lowercase letters, a number, and a special character (!#$%^&*)',
    password_mismatch: 'Passwords do not match',
    minLength: 'Password must be at least {minLength} characters long',
    maxLength: 'Password must not exceed {maxLength} characters',
    capital: 'Include at least one uppercase letter',
    lower: 'Include at least one lowercase letter',
    hasNumber: 'Include at least one number',
    specialChars: 'Include at least one special character (!#$%^&*)',
    passMust: 'Password must meet the following requirements:',
    passwordNotSame: 'Passwords do not match',
    email_invalid: 'Please enter a valid email address',
    INSTITUTION_ALREADY_EXISTS: 'Institution name already exists',
    TRIAL_ALREADY_USED: 'Trial already used',
    ACCESS_DENIED: 'Access denied',
    UNKNOWN_ERROR: 'Unknown error',
  },
  toasts: {
    patientAdded: 'Patient added successfully',
    patientUpdated: 'Patient updated successfully',
    patientDeleted: 'Patient deleted successfully',
    patientRestored: 'Patient restored successfully',
    patientTransferred: 'Patient transferred successfully',
    procedureAdded: 'Procedure added successfully',
    procedureUpdated: 'Procedure updated successfully',
    procedureDeleted: 'Procedure deleted successfully',
    visitAdded: 'Visit added successfully',
    visitUpdated: 'Visit updated successfully',
    visitDeleted: 'Visit deleted successfully',
  },
  signup: {
    alreadyhas: 'Already have an account?',
    login: 'Log in',
    title: 'Create Account',
    not_found: 'Invitation not found or expired. If you already have an account, try to Log in instead.',
    intro:
      'Hi {email}! You have been invited to create a {role} role account at Institution {institution} under Department {department}. Please fill out the following details to complete sign up.',
    introTrial:
      'Hi {email}! You have been created an {role} role account at Institution {institution} under Department {department}. Please fill out the following details to complete sign up.',
    fields: {
      first_name: 'First Name',
      last_name: 'Last Name',
      date_of_birth: 'Date of Birth',
      started_practising: 'When did you start your nursing career?',
      gender: 'Gender',
      email: 'E-mail',
      password: 'Password',
      password_confirm: 'Confirm Password',
    },
    actions: {
      signup: 'Sign Up',
      login: 'Log In',
    },
    success: {
      user_created: 'User {name} created successfully',
    },
  },
  institutionCreation: {
    institution: {
      title: 'Start free trial',
      discription:
        'Welcome! You’re creating a new institution on CoNurse to start a free 30-day trial. Please enter your institution, department, and email details. You will receive an invitation link on that email address to complete your sign-up.',
      name: 'Institution Name',
      street: 'Street',
      house: 'House',
      city: 'City',
      country: 'Country',
      county: 'County / Region',
      timezone: 'Timezone',
    },
    department: {
      title: 'Department',
      name: 'Department Name',
    },
    admin: {
      title: 'Institutional Admin User',
      email: 'Admin Email (person setting up the account)',
    },
    form: {
      accept_tos: 'I agree to the Terms of Service',
      accept_privacy: 'I agree to the Privacy Policy and Data Processing Agreement (DPA)',
    },
    actions: {
      start_free_trial: 'Start free trial',
    },
    messages: {
      created: 'Institution successfully created',
      wesend: 'We’ve sent a link to complete your registration to the email address',
      no_results: 'No results',
    },
  },
  success: {
    CREATED: 'Institution and department created successfully',
  },
  trialPage: {
    title: 'Trial expired.',
    message:
      'Trial ended on {date}. Your data will be deleted on {date2} unless a subscription is activated. Select a plan to continue using CoNurse.',
    cta: 'Select plan',
    support: 'Support',
  },
  gracePage: {
    disabled: 'Your account disabled!',
    title: 'Your subscription has ended',
    message:
      'Your subscription ended on {date}. Your data will be deleted on {date2} unless the subscription is renewed. Select a plan to continue using CoNurse.',
  },
  // end-new
  general: {
    ok: 'Ok',
    yes: 'Yes',
    no: 'No',
    cancel: 'CANCEL',
    // new
    confirm: 'CONFIRM',
    // end new
    close: 'Close',
    delete: 'Delete',
    remove: 'Remove',
    save: 'SAVE',
    edit: 'EDIT',
    view: 'View',
    add: 'Add',
    selectAll: 'Select all',
    dateAdded: 'Date added',
    dateUpdated: 'Date updated',
    lastUpdated: 'Last updated',
    loading: 'Loading ...',
    noData: 'No data',
    back: 'Back',
    next: 'Next',
    done: 'Done',
    accessDenied: 'Access Denied',
    name: 'Name',
    startDate: 'Start date',
    endDate: 'End date',
    open: 'Open',
    action: 'Action',
    categories: 'Categories',
    manage: 'MANAGE',
    saved: 'Saved',
    updated: 'Updated',
    deleted: 'Deleted',
    dragNDropFile: 'Drag and drop a file here, or:',
    browse: 'Browse',
    every: 'Every',
    onceEvery: 'Once every',
    created: 'Created',
    search: 'Search',
    chooseADate: 'Choose a date',
    average: 'Average',
    selectQuestion: 'Select question',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    enable: 'Enable',
    current: 'Current',
    noHistory: 'There is no history',
    invitationPending: 'Invitation pending',
    rows: 'rows',
    export: 'Export',
    startTime: 'Start time',
    endTime: 'End time',
    exportLocationHistory: 'Export location history',
    exportStopHistory: 'Export stop history',
    exportDateRangeTooLong: 'Date range cannot exceed {days} days',
    settings: 'Settings',
    signOut: 'Sign Out',
    clickToSort: 'Click to sort',
    duration: 'Duration',
    visitStart: 'Visit start',
    visitEnd: 'Visit end',
    // new
    subscriptionEnd: 'Trial active. Trial ends on {date}. Please choose a plan to continue.',
    graceActive: 'Grace period active. Your access ends on {date}. Please choose a plan to continue.',
    chooseplan: 'Choose plan',
    apply: 'Apply',
    optional: 'optional',
    // end new
    removeConfirmTitle: 'Remove item',
    removeConfirmText: 'Are you sure you want to remove this item?',
    selectGender: 'Select gender',
    gender: {
      male: 'Male',
      female: 'Female',
    },
  },
  time: {
    timePresets: 'Time Presets',
    today: 'Today',
    yesterday: 'Yesterday',
    pastNDays: 'Past {n} days',
    pastYear: 'Past year',
    allTime: 'All time',
    clearSelection: 'Clear Selection',
    jumpToToday: 'Jump to Today',
    previousWeek: 'previous week',
    previousMonth: 'previous month',
  },
  charts: {
    nMostFrequentlyProcedures: '{n} most frequently started procedures',
    nLeastFrequentlyProcedures: '{n} least frequently started procedures',
    oftenAssistedProcedures: 'Often assisted procedures',
    nursesExperience: "Nurses' experience",
    nursesGender: "Nurses' gender",
    nursesAge: "Nurses' Age",
    workIntensityChart: 'Work intensity chart',
    surveyChart: 'Survey Chart',
    nurses: 'Nurses',
    Averageshiftduration: 'Average shift duration',
    Averageshiftintensity: 'Average shift intensity',
    Averagenrofpatients: 'Average nr of patients',
    Averageacuitypershift: 'Average acuity per shift',
    lessThenYear: 'Less than 1 year',
    yearToFiveYears: '1-5 years',
    fiveToTenYears: '5-10 years',
    moreThanTenYears: 'More than 10 years',
    maleNurses: 'Male nurses',
    femaleNurses: 'Female nurses',
    'tiredness chart': 'Tiredness chart',
    'tiredness score': 'Tiredness score',
    'intensity score': 'Intensity score',
    'work intensity chart': 'Work intensity chart',
    selectStudy: 'Select study',
    count: 'Count',
    tiredness: 'Tiredness',
    intensity: 'Intensity',
  },
  form: {
    thisFieldIsRequired: 'This field is required',
    canNotStartBeforeParentStarts: 'Can not start before parent starts',
    canNotStartWhenParentEnded: 'Can not start when parent ended',
    canNotEndBeforeParentStarts: 'Can not end when parent not started',
    canNotEndWhenParentEnded: 'Can not end when parent ended',
    canNotEndBeforeStart: 'Can not end before start',
    canNotStartAfterEnd: 'Can not start after end',
    insertNumber: 'Insert number',
    days: 'Day(s)',
    weeks: 'Week(s)',
    months: 'Month(s)',
    years: 'Year(s)',
  },
  menu: {
    home: 'Home',
    departments: 'Departments',
    institutions: 'Institutions',
    users: 'Users',
    scheduling: 'Scheduling',
    procedures: 'Procedures',
    manageProcedures: 'Manage Procedures',
    manageCategories: 'Manage Categories',
    study: 'Study',
    survey: 'Survey',
    procedure: 'Procedure',
    reinviteusers: 'Re-Invite Users',
    userGuide: 'User Guide',
    devices: 'Devices',
    groups: 'Groups',
    learningobject: 'Learning Objects',
    manageStudies: 'Manage Studies',
    statistics: 'Statistics',
    reports: 'Reports',
    deviceGroups: 'Device Groups',
    patients: 'Patients',
    nurseLocation: 'Nurse location',
    usersList: 'Users list',
    visitForms: 'Visit forms',
    billing: 'Billing Portal',
    approvalRequests: 'Approval Requests',
  },
  approvalRequest: {
    actionType: 'Action Type',
    requestedBy: 'Requested By',
    approvedBy: 'Approved By',
    confirms: {
      approveTitle: 'Approve request',
      approveText: 'Are you sure you want to approve this request?',
      rejectTitle: 'Reject request',
      rejectText: 'Please provide a reason for rejecting this request.',
      rejectReasonPlaceholder: 'Rejection reason',
    },
    actionTypes: {
      PERMISSION_GRANT: 'Permission Grant',
      PERMISSION_REVOKE: 'Permission Revoke',
      EXPORT_VISITS: 'Export Visits',
      EXPORT_LOCATION_HISTORY: 'Export Location History',
      EXPORT_ARRIVAL_HISTORY: 'Export Arrival History',
      ENABLE_USER: 'Enable User',
      DISABLE_USER: 'Disable User',
    },
    toasts: {
      created: 'Approval request created',
      applied: 'Action applied',
      applyFailed: 'Failed to apply action',
      approved: 'Request approved',
      approveFailed: 'Failed to approve request',
      rejected: 'Request rejected',
      rejectFailed: 'Failed to reject request',
    },
  },
  procedures: {
    procedures: 'Procedures',
    searchProcedures: 'Search procedures',
    addProcedure: 'Add procedure',
    deleteProcedure: 'Delete procedure',
    filter: 'Filter',
    sort: 'Sort',
    public: 'Public',
    private: 'Private',
    department: 'Department',
    category: 'Category',
    publicPrivate: 'Public/Private',
    importProcedures: 'Import procedures',
    addAndSchedule: 'Add and schedule procedures for device groups',
    addAnother: 'Add another procedure',
    selectType: 'Select type',
    saveProcedure: 'Save procedure',
    noFrequency: 'No frequency added',
  },
  procedure: {
    name: 'Name',
    disableProcedure: 'Disable procedure',
    type: 'Type',
    revisionHistory: 'Revision history',
    addProceduresInformation: 'Add procedure information',
    editProceduresInformation: 'Edit procedure information',
    duplicateStartEndStepWarning: 'Only 1 start and 1 end step is allowed',
    procedureNotFound: 'Procedure not found',
    category: 'Category',
    authors: 'Author',
    owner: 'Owner',
    languagesAvailable: 'Languages available',
    publicPrivate: 'Public/Private',
    defineFeedback: 'Define feedback',
    seeFeedback: 'See feedback',
    statistics: 'Statistics',
    description: 'Description',
    information: 'Information',
    step: 'Step',
    media: 'Media',
    allSteps: 'All steps',
    createNewStep: 'Add step',
    viewAs: 'View as',
    searchSteps: 'Search steps...',
    procedureName: 'Procedure name',
    procedureCategory: 'Procedure category',
    language: 'Language',
    procedureLanguage: 'Procedure language',
    public: 'Public',
    unableToLoad: 'Unable to load procedure',
    department: 'Department',
    addNewCategory: 'ADD NEW CATEGORY',
    institution: 'Institution',
    import: 'Import',
    stepNr: 'Nr',
    deleteStep: 'Confirm to delete step ',
    lastUpdated: 'Last updated',
    startTime: 'Procedure start time',
    endTime: 'Procedure end time',
    mustDisableTitle: 'Procedure must be disabled to edit',
    mustDisableText: 'This procedure is currently enabled. Disable it now to make changes?',
    validityChecklistTitle: 'Procedure validity check',
    validityAllValid: 'All checks passed — this procedure can be enabled.',
    validityHasIssues: 'This procedure cannot be enabled until the following issues are fixed:',
    validityLoadFailed: 'Could not check procedure validity. Please try again.',
    checklist: 'Checklist',
    status: 'Status',
    revisionDate: 'Date',
    revisionUser: 'User',
    revisionChanges: 'Changes',
    revisionStepAdded: 'added',
    revisionStepRemoved: 'removed',
    revisionStepUpdated: 'updated',
    revisionStepReordered: 'reordered',
  },
  reports: {
    reports: 'Reports',
    chooseADate: 'Choose a date',
    userID: 'User ID',
    deviceGroup: 'Device Group',
    allReports: 'All reports',
    failedAudits: 'Failed audits',
    reportDate: 'Report date',
    all: 'All',
    successfull: 'Successful',
    failed: 'Failed',
    finished: 'Finished',
    stopped: 'Stopped',
    started: 'Started',
    deviceStatistics: 'Device statistics',
    devicesInUse: 'Devices in use',
    deviceAudits: 'Device audits',
    auditComingSoon: 'Audit coming soon',
    auditNotDone: 'Audit not done',
    auditDone: 'Audit done',
    averageTimeSpentOnProcedure: 'Average time spent on procedure',
    selectProcedure: 'Select procedure',
    noGroupSelected: 'No group selected',
    rateFailedAudits: 'Rate of devices failed the audits',
    proceduresHistory: 'Procedures history',
    procedureStatus: 'Procedure status',
    noProcedureHistory: 'No procedure history',
  },
  devices: {
    group: 'Group',
    devices: 'Devices',
    searchDevices: 'Search devices',
    addDevice: 'Add device',
    addDevices: 'Add devices',
    addAnotherDevice: 'Add another device',
    deleteDevice: 'Delete device',
    filter: 'Filter',
    sort: 'Sort',
    public: 'Public',
    private: 'Private',
    department: 'Department',
    category: 'Category',
    publicPrivate: 'Public/Private',
    importDevices: 'Import devices',
    allDevices: 'All devices',
  },
  device: {
    device: 'Device',
    name: 'Name',
    disableDevice: 'Disable device',
    revisionHistory: 'Revision history',
    editDevicesInformation: 'Edit device information',
    deviceNotFound: 'Device not found',
    category: 'Category',
    authors: 'Author',
    owner: 'Owner',
    languagesAvailable: 'Languages available',
    publicPrivate: 'Public/Private',
    defineFeedback: 'Define feedback',
    seeFeedback: 'See feedback',
    statistics: 'Statistics',
    description: 'Description',
    information: 'Information',
    media: 'Media',
    viewAs: 'View as',
    deviceName: 'Device name',
    deviceCategory: 'Device category',
    language: 'Language',
    deviceLanguage: 'Device language',
    public: 'Public',
    unableToLoad: 'Unable to load device',
    department: 'Department',
    group: 'Group',
    addNewCategory: 'ADD NEW CATEGORY',
    institution: 'Institution',
    import: 'Import',
    model: 'Device Model',
    lifeCycleNum: 'Life Cycle Number',
    lifeCycleTime: 'Life Cycle Time',
    lifeCycle: 'Life Cycle',
    udi: 'UDI',
    udiQrCodef: 'UDI for QR code',
    uuid: 'UUID',
    orUploadPicture: 'or upload picture of QR code',
    dropFile: 'Drag and drop a file here, or:',
    lastUpdated: 'Last updated',
    viewStatistics: 'View statistics',
    auditFrequency: 'Audit frequency',
    auditProcedure: 'Audit procedure',
    lifeCycleStart: 'Life cycle start',
    lifeCycleEnd: 'Life cycle end',
    deviceProcedureHistory: 'Device Procedure History',
    comments: 'Comments',
    commented: 'commented',
    groupName: 'Group name',
    audit: 'Audit',
    other: 'Other',
    udiAlreadyExists: 'this UDI already exists',
    status: 'Status',
  },
  step: {
    transitionToNextStep: 'Transition to next step',
    transitionType: 'Transition type',
    parentStep: 'Parent step',
    previousStep: 'Previous step',
    option: 'Option',
    editStep: 'Edit Step',
    description: 'Description',
    addNewStep: 'Add new step',
    owner: 'Owner',
    viewInProcedure: 'View in procedure',
    stepMedia: 'Step media',
    saveMedia: 'Save',
    dropFilesOrClickToUpload: 'Drop files here or click to upload',
    addDescription: 'Add description',
    chooseType: 'Choose type',
    insertOption: 'Insert option',
    insertMinValue: 'Insert MIN value',
    insertMaxValue: 'Insert MAX value',
    chooseTransitionType: 'Choose transition type',
    chooseParentSep: 'Choose parent step',
    chooseStepOption: 'Choose step option',
    addParentStep: 'Add parent step',
    type: 'Type',
    value: 'Value',
    error: {
      WONT_REACH_END: 'No path to END',
      EXIT_NOT_IN_USE: 'Unused exit',
      NO_PARENT_SET: 'Has no previous step',
      PARENT_NOT_EXITS: 'Defined parent does not exit',
      DUPLICATE_START: 'Procedure can only have one START step',
      DUPLICATE_END: 'Procedure can only have one END step',
      NO_START: 'Procedure has no START step',
      NO_END: 'Procedure has no END step',
      MULTIPLE_CHILDREN_FOR_EXIT: 'Exit is used by more than one step',
    },
  },
  department: {
    institution: 'Institution name',
    createNewDepartment: 'Add department',
    searchDepartments: 'Search department(s)',
    departmentName: 'Department name',
    institutionName: 'Institution name',
    departmentAdmin: 'Department admin',
    thisFieldIsRequired: 'This field is required',
    addDepartment: 'Add department',
    editDepartment: 'Edit department',
    edit: 'Edit',
    updatedDepartment: 'Department updated successfully',
    createdNewDepartment: 'Department created successfully',
    deleteDepartment: 'Delete department',
    deletedDepartment: 'Department deleted',
    reassignTo: 'Reassign to department',
    noReassignmentTarget:
      'This is the only department in the institution. Create another department before deleting this one.',
    showArchived: 'Show archived departments',
    restore: 'Restore',
    restoredDepartment: 'Department restored',
    confirms: {
      deleteTitle: 'Delete {name}?',
      deleteText:
        'All users, procedures, learning objects, studies, and devices in this department will be reassigned to the department you select below. This cannot be undone.',
      restoreTitle: 'Restore {name}?',
      restoreText: 'This will make the department visible again and restore access for its staff.',
    },
  },
  user: {
    // new translations
    deleted: 'User/s deleted',
    totalUsers: 'Total users',
    seatCap: 'Seat cap',
    users: 'users',
    seatsUsed: 'Seats used',
    seatsRemaining: 'seats remaining',
    confirms: {
      deleteTitle: 'Delete {count} user(s)',
      deleteText: 'Deleting user(s) is irreversible. Are you sure you wish to delete the user(s)?',

      disableTitle: 'Disable subscription for {count} user(s)',
      disableText:
        'Are you sure you want to disable the subscription for the selected user(s)? This will revoke access to both the CoNurse app and the CMS.',

      activateTitle: 'Activate subscription for {count} user(s)',
      activateText:
        'Are you sure you want to activate the subscription for the selected user(s)? This will grant access to the app and the CMS.',

      notAbleActivateTitle: 'Not able to activate subscription for {count} user(s)',
      notAbleActivateText:
        'You can only activate subscription for users who are currently disabled. Please adjust your selection to include only disabled users.',

      notAbleActivateLimitTitle: 'Not able to activate subscription for {count} user(s)',
      notAbleActivateLimitText:
        'Cannot activate subscription for {count} user(s), this exceeds your seat limit by {seats} seats.',

      notAbleDisableTitle: 'Not able to disable subscription for {count} user(s)',
      notAbleDisableText:
        'You can only disable subscription for users who currently have an active subscription. Please adjust your selection to include only active users.',

      seatLimitReachedTitle: 'Seat limit reached',
      seatLimitReachedText: 'Your plan only allows {limit} user(s). Upgrade plan to add more users.',

      inviteActivateLimitTitle: 'Not able to invite {count} user(s)',
      inviteActivateLimitText: 'Cannot invite {count} user(s), this exceeds your seat limit by {seats} seats.',

      inviteSeatLimitReachedTitle: 'Seat limit reached',
      inviteSeatLimitReachedText: 'Your plan only allows {limit} user(s). Upgrade plan to invite more users.',

      revokeRoleTitle: 'Revoke role',
      revokeRoleText: "Are you sure you want to revoke this user's role?",
      revokeRoleSuccess: 'Role revoked',
      revokeRoleFailed: 'Failed to revoke role',
      revokeRoleNoRole: 'No role assignment found for this user',
    },

    lastActive: 'Last active',
    selected: 'users selected',
    chooseAction: 'Choose action',
    deleteSelected: 'Delete selected',
    disableSelected: 'Disable selected',
    enableSelected: 'Enable selected',
    // new translations end
    inviteUsers: 'Invite users',
    reInviteUsers: 'Re-invite users',
    searchUsers: 'Search user(s)',
    user: 'User',
    institutionAndDepartment: 'Institution and department',
    subscription: 'Subscription',
    chooseUserRole: 'Choose user role',
    userRole: 'User role',
    // new
    selectRole: 'Select role',
    selectDepartment: 'Select department',
    // end new
    emails: 'User email(s)',
    department: 'Department',
    departmentAdmin: 'Department admin',
    emailsDescription:
      'Insert 1 or more e-mails, separated by semicolon. Invitations to register as the chosen user role will be sent to the users via email.',
    thisFieldIsRequired: 'This field is required',
    nurse: 'Nurse',
    patient: 'Patient',
    contentEditor: 'Content Editor',
    projectAdmin: 'Project Admin',
    familyMember: 'Family Member',
    institutionalAdmin: 'Institutional admin',
    institution: 'Institution',
    filter: 'Filter',
    sort: 'Sort',
    accountSettings: 'Account settings',
    logOut: 'Log Out',
    contactInformation: 'Contact information',
    dateOfBirth: 'Date of birth',
    gender: 'Gender',
    contact: 'Contact',
    password: 'Password',
    userInformation: 'User information',
    resetPassword: 'Reset password',
    sendResetPasswordEmailTo: 'Send reset password email to',
    resetRequestSentTo: 'Password rest email sent to',
    userDetailsUpdated: 'User details updated',
    noUsersSelected: 'No users selected',
    invite: 'INVITE',
    grantRole: 'GRANT ROLE',
    revokeRole: 'REVOKE ROLE',
    homeNurse: 'Home nurse',
  },
  institution: {
    name: 'Name',
    region: 'Region',
    contact: 'Contact',
    searchInstitutions: 'Search institution(s)',
    createNewInstitution: 'Add institution',
    editInstitution: 'Edit institution',
    switch: 'Switch',
    unableToSwitch: 'Unable to switch',
    switchedTo: 'Institutions switched to',
    street: 'Street',
    institutionStreet: 'Street',
    institutionHouse: 'House',
    institutionCity: 'City',
    institutionCounty: 'County',
    institutionCountry: 'Country',
    institutionTimezone: 'Timezone',
    institutionLanguage: 'Language',
    stopDetectionDuration: 'Stop detection duration (minutes)',
    createdNewInstitution: 'Created new institution',
    updatedInstitution: 'Updated institution',
    edit: 'Edit',
    showArchived: 'Show archived institutions',
    deleteInstitution: 'Delete institution',
    deletedInstitution: 'Institution deleted',
    restore: 'Restore',
    restoredInstitution: 'Institution restored',
    accessRevoked: 'Your institution has been removed. You have been logged out.',
    confirms: {
      deleteTitle: 'Delete {name}?',
      deleteText:
        'This will hide the institution and its departments from the admin panel and immediately revoke access for all of its staff. This can be undone by restoring the institution.',
      restoreTitle: 'Restore {name}?',
      restoreText: 'This will make the institution and its departments visible again and restore access for its staff.',
    },
  },
  datatable: {
    rowsPerPage: 'Rows per page',
  },
  study: {
    name: 'Name',
    studyName: 'Study name',
    status: 'Status',
    department: 'Department',
    author: 'Author',
    owner: 'Owner',
    duration: 'Duration',
    startDate: 'Start date',
    endDate: 'End Date',
    searchStudy: 'Search studies',
    addStudy: 'Add study',
    description: 'Description',
    visibility: 'Visibility',
    permission: {
      department: 'Department',
      institution: 'Institution',
    },
    createdNewStudy: 'Created new study',
    updatedStudy: 'Updated study',
    deleteStudy: 'Delete study',
    editStudy: 'Edit study',
    deletedStudy: 'Deleted study',
  },
  studyResults: {
    user: 'User',
    department: 'Department',
    study: 'Study',
    date: 'Date',
    survey: 'Survey',
    results: 'Results',
    studyResults: 'Study Results',
    surveyResults: 'Survey Results',
    list: 'List',
    graph: 'Graph',
    surveyStartDate: 'Survey Start',
    surveyEndDate: 'Survey End',
    userResults: 'User Results',
    question: 'Question',
    questionType: 'Question Type',
    answer: 'Answer',
    position: 'Position',
    scaleAnswerFormat: '{value} — {meaning}',
  },
  survey: {
    key: 'Key',
    name: 'Name',
    surveyName: 'Survey name',
    editSurvey: 'Edit survey',
    addPeriodButton: 'ADD NEW PERIOD',
    addQuestionButton: 'ADD NEW QUESTION',
    allAssessmentPeriods: 'All assessment periods',
    createNewPeriod: 'Create new period',
    createNewSurvey: 'Create new survey',
    addAssessmentPeriod: 'Create new sub-period',
    addSurveyPeriod: 'Create new survey period',
    periodName: 'Name',
    completePreviousPeriods: 'Does the study participant have to complete a previous period(s) to enable this period?',
    startDate: 'Start date',
    endDate: 'End date',
    author: 'Author',
    duration: 'Duration',
    type: 'Type',
    SURVEY_PERIOD: 'SURVEY PERIOD',
    NONE: 'NONE',
    ASSESSMENT_PERIOD: 'ASSESSMENT PERIOD',
    addPeriod: 'Add new period',
    questionList: 'Questions',
    added: 'Created new survey',
    createNewQuestion: 'Add question',
    addNew: 'Add new',
    period: 'Period',
    question: 'Question',
    position: 'Position',
    surveyHasOverallScore: 'Does the survey have an overall score?',
    howScoreCalculated: 'How is the overall score calculated?',
    surveyHasCategoryScore: 'Does the survey have a category specific score?',
    sumAnswers: 'Sum of all answers',
    avgAnswers: 'Average of all answers',
    basicInformation: 'Basic Information',
    surveyScore: 'Survey Score',
    addAnotherCategory: 'Add another category',
    selectOption: 'Select option',
    selectSurvey: 'Select survey',
    jobEngagement: 'Job-engagement',
    burnoutScores: 'Burnout scores',
    viewScores: 'VIEW SCORES',
    hasOverallScore: 'Survey has overall score',
    hasNoOverallScore: 'Survey has no overall score',
    noChartData: 'No chart data',
    selectChartType: 'Select chart type',
    surveyCategoryInfo:
      'The survey has categories to organize questions. You have the ability to modify and oversee them in this section.',
  },
  question: {
    name: 'Name',
    type: 'Type',
    questionType: 'Question type',
    position: 'Position',
    details: 'Details',
    question: 'Question',
    answers: 'Answers',
    set: 'Set',
    text: 'Text',
    options: 'Options',
    value: 'Value',
    meaning: 'Meaning',
    category: 'Category',
    types: {
      CHOICE: 'Choice',
      SCALE: 'Scale',
      COGNITION: 'Cognition',
      FREE_TEXT: 'Free Text',
      MULTI_CHOICE: 'Checkbox',
      MEDIA: 'Media',
    },
    added: 'Created new question',
    updated: 'Question updated',
    cognitionName: 'Cognition name',
    cognitionType: 'Cognition type',
    editQuestion: 'Edit question',
  },
  category: {
    category: 'Category',
    name: 'Name',
    description: 'Description',
    shortDescription: 'Short description',
    type: 'Type',
    types: {
      PROCEDURE: 'Procedure',
      QUESTION: 'Question',
      DEVICE: 'Device',
    },
    createdNewCategory: 'Created new category',
    updatedCategory: 'Updated category',
    deletedCategory: 'Deleted category',
    manageCategories: 'Manage categories',
    addCategory: 'Add category',
    editCategory: 'Edit category',
    deleteCategory: 'Delete category',
    createAnother: 'Create another category',
    deleteAlert:
      'Deleting this category is irreversible. Move its questions to an existing category or leave them unsorted.',
    deleteMoveTarget: 'Where should the questions from this category go?',
    noCategory: 'No category',
    searchCategories: 'Search categories',
    frequency: 'Frequency',
    reassignTo: 'Reassign to',
    reassignAllAtOnce: 'Reassign without previewing',
    reassignOneByOne: 'Preview affected procedures before reassigning',
    confirms: {
      deleteTitle: 'Delete {name}?',
      deleteTextImmediate: 'This category has no procedures and can be deleted immediately. This cannot be undone.',
      chooseReassignMode: 'This category still has procedures. Choose how to reassign them before deleting.',
      deleteTextAllAtOnce: 'Choose a category to move all procedures to. This cannot be undone.',
      deleteTextOneByOne: 'Review the procedures below, then choose a category to move them all to.',
      affectedProcedures: 'Procedures that will move',
      andNMore: '...and {count} more',
      stillHasProcedures: 'This category still has procedures assigned to it. Please choose a target category.',
    },
  },
  groups: {
    createNewGroup: 'Add group',
    searchGroups: 'Search group(s)',
    addGroup: 'Add group',
    newGroup: 'New group',
    groupName: 'Group name',
    lifeCycleEndingSoon: 'Life cycle ending soon',
    lifeCycleEnded: 'Life cycle ended',
    happyDevices: 'Happy devices',
    searchDeviceGroups: 'Search device groups',
    backToGroups: 'Back to device groups',
    saveGroup: 'Save group',
  },
  group: {
    name: 'Name',
    description: 'Description',
    createdNewGroup: 'Created new group',
    updatedGroup: 'Updated group',
    groupCategory: 'Group category',
    category: 'Category',
    addNewCategory: 'ADD NEW CATEGORY',
    language: 'Language',
    groupLanguage: 'Group language',
    public: 'Public',
    private: 'Private',
    groupName: 'Group name',
    departmentName: 'Department name',
    created_at: 'Created at',
    notFound: 'Group not found',
    notCreated: 'Not created',
    noImage: 'No image added',
  },
  learningObject: {
    addLearningObject: 'Add learning object',
    searchLearningObject: 'Search learning objects',
    name: 'Name',
    department: 'Department',
    content: 'Content',
    isEnabled: 'Enabled',
    updatedLearningObject: 'Updated learning object',
    createdNewLearningObject: 'Created new learning object',
    author: 'Author',
    owner: 'Owner',
    editLearningObject: 'Edit learning object',
    deleteLearningObject: 'Delete learning object',
    learningObjectDeleted: 'Deleted learning object',
  },
  manual: {
    userManuals: 'User manuals',
    userManual: 'User Manual',
    chooseOrWrite: 'Choose an existing user manual or write a new one.',
    userManualName: 'User Manual name',
    writeText: 'Write user manual text',
    input: 'Input',
    saveUserManual: 'Save user manual',
    addUserManual: 'Add another user manual',
    writeNew: 'or use write a new user manual',
    searchExisting: 'Search existing user manual...',
  },
  patients: {
    patientName: 'Patient name',
    patientAssignedTo: 'Patient assigned to',
    standingAssignment: 'Standing assignment',
    noStandingAssignment: 'No standing assignment',
    unknownNurse: 'Assigned nurse (name unavailable)',
    standingAssignmentHelperText: 'Only Home Nurse users can be set as a standing assignment.',
    changeStandingAssignment: 'Change assignment',
    clearStandingAssignment: 'Clear assignment',
    confirmClearStandingAssignmentText: 'Are you sure you want to clear the standing assignment for this patient?',
    transferPatient: 'Transfer patient',
    transferPatientHelperText:
      'Move this patient to another department. Clinical data follows the patient; the nurse standing assignment will be cleared.',
    selectTargetDepartment: 'Target department',
    upcomingScheduledItemsHelperText:
      'Choose whether each upcoming visit or procedure should be cancelled or left open for the receiving department.',
    noUpcomingScheduledItems: 'This patient has no upcoming scheduled visits or procedures.',
    cancelAllItems: 'Cancel all',
    keepItem: 'Keep',
    cancelItem: 'Cancel',
    confirmTransfer: 'Confirm transfer',
    procedure: 'Procedure',
    lockedDepartmentHint: 'Use Transfer to move this patient to another department.',
    standingAssignmentLabel: '{name} (standing)',
    onShiftLabel: '{name} (on shift)',
    currentlyOnShiftWith: 'Currently on shift with',
    notCurrentlyOnShift: 'Not currently on shift',
    assignmentHistory: 'Assignment history',
    viewAssignmentHistory: 'View assignment history',
    standingAssignments: 'Standing assignments',
    shiftAssignments: 'Shift assignments',
    assignedFrom: 'Assigned from',
    assignedTo: 'Assigned to',
    changedBy: 'Changed by',
    shiftStart: 'Shift start',
    shiftEnd: 'Shift end',
    duration: 'Duration',
    datePatientAdded: 'Date patient added',
    status: 'Status',
    nextVisit: 'Next visit',
    addPatient: 'Add patient',
    editPatient: 'Edit patient',
    deletePatient: 'Delete patient',
    showArchived: 'Show archived patients',
    excludeAssignedPatients: 'Hide patients with a Home Nurse assigned',
    restore: 'Restore',
    importPatients: 'import patients',
    patientSearch: 'Patient search',
    confirms: {
      deleteTitle: 'Delete patient',
      deleteText:
        'This will hide the patient — along with their upcoming visits, procedures, allergies, medications, visit history, and consent records — from the active patient list and revoke access to their data. This can be undone by restoring the patient.',
      restoreTitle: 'Restore patient',
      restoreText: 'Are you sure you want to restore this patient? They will reappear in the active patient list.',
    },
    scheduleVisit: 'Schedule a visit',
    primaryDiagnosis: 'Primary diagnosis',
    secondaryDiagnosis: 'Secondary diagnosis',
    patientHistory: 'Patient history',
    visitName: 'Name',
    visitDate: 'Date',
    performedBy: 'Performed by',
    enterName: 'Enter name',
    birthDate: 'Birth date',
    visitAddress: 'Visit address',
    enterAddress: 'Enter address',
    email: 'Email',
    enterPatientEmail: "Enter patient's email",
    phoneNumber: 'Phone number',
    enterPatientNumber: "Enter patient's phone number",
    enterPrimaryDiagnosis: 'Enter primary diagnosis',
    enterSecondaryDiagnosis: 'Enter secondary diagnosis',
    note: 'Note (optional)',
    enterShortNote: 'Enter short note',
    location: 'Location / ward room (optional)',
    enterLocation: 'Enter location or ward room',
    admissionDate: 'Admission date (optional)',
    dischargeDate: 'Discharge date (optional)',
    acuity: 'Acuity (optional)',
    assignedNurse: 'Assigned nurse',
    fileRequirements: 'File requirements',
    firstRequirement: 'Please upload a CSV or XLSX file',
    secondRequirement: 'Less than 500 KB',
    unsupportedFieldsNotice:
      'Allergy, medication, height, weight, patient type and condition code/name are not supported by this import — add them manually after import.',
    importPatientsModalTitle: 'Import patients',
    selectTargetDepartmentForImport: 'Import into department',
    uploadCsvOrXls: 'Click or drag a CSV or XLSX file to this area to upload',
    downloadTemplate: 'Download template',
    willImport: 'Will import',
    duplicateSkipped: 'Duplicate (skipped)',
    importError: 'Error',
    confirmImport: 'Confirm import',
    import: {
      status: 'Status',
      details: 'Details',
      unsupportedFileType: 'Unsupported file type. Please upload a CSV, XLS or XLSX file.',
      fileTooLarge: 'File is too large. Maximum size is 500 KB.',
      uploadFailed: 'Failed to upload and validate the file. Please try again.',
      confirmFailed: 'Failed to import patients. Please try again.',
      importSucceeded: '{created} patient(s) imported, {duplicates} duplicate(s) skipped.',
      departmentsLoadFailed: 'Failed to load departments. Please try again.',
    },
    allergy: 'Allergy',
    allergies: 'Allergies',
    allergyType: 'Allergy type (optional)',
    medications: 'Medications',
    procedures: 'Procedures',
    reaction: 'Reaction (optional)',
    severity: 'Severity (optional)',
    addAnotherAllergy: 'Add another allergy',
    medication: 'Medication',
    medicationType: 'Medication type',
    dosage: 'Dosage',
    frequency: 'Frequency',
    startDateOptional: 'Start date (optional)',
    durationOptional: 'Duration (optional)',
    addAnotherMedication: 'Add another medication',
    addAnotherProcedure: 'Add another procedure',
    visit: 'Visit',
    visitStartTime: 'Visit start time',
    visitEndTime: 'Visit end time',
    selectNurse: 'Select nurse',
    nurseMissing: 'Please assign a nurse first',
    addAnotherVisit: 'Add another visit',
    sex: 'Sex',
    addNewAllergy: 'Add new allergy',
    addNewMedication: 'Add new medication',
    addNewProcedure: 'Add new procedure',
    assignedProcedures: 'Assigned procedures',
    scheduledProcedures: 'Scheduled procedures',
    upcomingVisits: 'Upcoming visits',
    canceledVisits: 'Cancelled visits',
    pastVisits: 'Past visits',
    missedVisits: 'Missed visits',
    department: 'Department',
    departmentOptional: 'Department (optional)',
    scheduledVisits: 'Scheduled visits',
    visitAssignedTo: 'Visit assigned to',
    stable: 'Stable',
    improving: 'Improving',
    deteriorating: 'Deteriorating',
    notAssigned: 'Not assigned',
    ongoing: 'Ongoing',
    pending: 'Pending',
    finished: 'Finished',
  },
  visitReport: {
    consent: 'Consent',
    viewConsent: 'View consent',
    homeVisit: 'Home visit',
    recomendationForTreatment: 'Recomendations for treatment, care, work, and outpatient supervision',
    anamnesis: 'Anamnesis',
    answerType: 'Answer type',
    contactPhone: 'Contact phone',
    contactEmail: 'Contact email',
    visitMadeBy: 'Visit made by',
    homeVisitTime: 'Home visit time',
    visitForm: 'Visit form',
    viewHistory: 'View history',
    patientsPrimaryHealthConcern: 'Patients primary health concern',
    conditionAssesmentInformation: 'Condition assessment information',
    bloodPressure: 'Blood pressure',
    measurement: 'Measurement',
    BMI: 'BMI',
    diagnosis: 'Diagnosis',
    appliedMedicalTreatments: 'Applied medicinal treatment',
    appliedTreatment: 'Applied treatment',
    descriptionOfTestsConsultationPlans: 'Description of tests/consultation plans',
    instrumentalTests: 'Instrumental tests',
    laboratoryTests: 'Laboratory tests',
    appliedMedicalTreatment: 'Applied medical treatment',
    specialist: 'Specialist',
    status: 'Status',
    complaintData: 'Complaint data',
    pulse: 'Pulse',
    viewFullVisitForm: 'View full visit form',
    height: 'Height',
    weight: 'Weight',
  },
  titles: {
    // new
    billingplans: 'Billing Plans',
    reinviteusers: 'Re-Invite Users',
    // end new
    home: 'Home',
    institutions: 'Institutions',
    departments: 'Departments',
    categories: 'Procedure Categories',
    users: 'Users',
    nurselocation: 'Nurse Location',
    procedures: 'Procedures',
    study: 'Study',
    learningobjects: 'Learning Objects',
    patients: 'Patients',
    patient: 'Patient',
    'visit forms': 'Visit Forms',
    backToUsers: 'Back to users',
    backToVisits: 'Back to visits',
    backToPatientsList: 'Back to patients list',
    backToPatient: 'Back to patient',
    backToProcedures: 'Back to procedures',
    backToProcedure: 'Back to procedure',
    backToStudyList: 'Back to study list',
    backToStatistics: 'Back to statistics',
    backToStudy: 'Back to study',
    backToLearningObjects: 'Back to learning objects',
    studyresults: 'Study results',
    studyview: 'Study view',
    learningobjectdetail: 'Learning object details',
    subscription: 'Subscription',
    scheduling: 'Scheduling',
    signup: 'Signup',
    userresults: 'User results',
    devices: 'Devices',
    device: 'Device',
    groups: 'Groups',
    group: 'Group',
    groupadd: 'Add Group',
    devicereports: 'Device reports',
    devicecharts: 'Device charts',
    visitforms: 'Visit forms',
    visitreport: 'Visit report',
    procedure: 'Procedure',
    step: 'Step',
    addpatient: 'Add patient',
    editpatient: 'Edit patient',
    survey: 'Survey',
    surveyresults: 'Survey results',
    approvalrequests: 'Approval Requests',
  },
  nurseRoute: {
    viewRoute: 'View route',
    liveShift: 'On shift',
    noActiveShift: 'No active shift',
    shiftEnded: 'Shift ended — showing saved route',
    shiftAutoClosed: 'Shift automatically closed (duration expired) — showing saved route',
    lastUpdated: 'Last updated: {time}',
    refreshHint: 'live route; stops sync periodically',
    historyFrom: 'Route history available from {date} onwards',
    timeSpent: 'Time spent',
    minutes: 'min',
    loadFailed: 'Could not load route',
    zoomToStop: 'Zoom to stop',
    stopAddress: 'Address',
    stopArrival: 'Arrival',
    stopDeparture: 'Departure',
    stopDuration: 'Duration',
  },
} as const;
